module.exports = __webpack_public_path__ + "static/media/triple-treasures.68ebf61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/triple-treasures.png
// module id = 1365
// module chunks = 1